import { render, staticRenderFns } from "./PageForgotPasswordSet.vue?vue&type=template&id=3ab6aac6&scoped=true&"
import script from "./PageForgotPasswordSet.vue?vue&type=script&lang=ts&"
export * from "./PageForgotPasswordSet.vue?vue&type=script&lang=ts&"
import style0 from "./PageForgotPasswordSet.vue?vue&type=style&index=0&id=3ab6aac6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab6aac6",
  null
  
)

export default component.exports